export default __webpack_public_path__ + "static/media/edit.3a016870.svg";